import React from "react";

import ChannelScreen from "@/screens/Messaging/ChannelScreen";

export default function page(): React.JSX.Element {
  return <ChannelScreen />;
}
